import react from 'react';

import FormCadastro from '../../../components/forms/gerenciamento/FormCadastro';

const Cadastro = () => {
    return (
        <>
        <FormCadastro />
        </>
    )
}

export default Cadastro;